import { queryOptions } from '@tanstack/react-query'
import { fetchActiveAgreements, fetchMissingConsents } from './agreement.api'

export const agreementQueryKeys = {
  active: ['agreement', 'active'] as const,
  missing: ['agreement', 'missing'] as const,
}

export const activeAgreementsQuery = () =>
  queryOptions({
    queryKey: agreementQueryKeys.active,
    queryFn: fetchActiveAgreements,
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
  })

export const missingConsentsQuery = () =>
  queryOptions({
    queryKey: agreementQueryKeys.missing,
    queryFn: fetchMissingConsents,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
  })
